import { useEffect, useState } from 'react'
import { StyleSheet } from 'react-native'
import { Searchbar, useTheme } from 'react-native-paper'

interface DebouncedSearchbarProps {
    placeholder: string
    value: string
    onChangeText: (text: string) => void
}

export function DebouncedSearchbar({ placeholder, value, onChangeText }: DebouncedSearchbarProps) {
    const theme = useTheme()
    const [localSearch, setLocalSearch] = useState(value)

    useEffect(() => {
        const handler = setTimeout(() => {
            onChangeText(localSearch)
        }, 300)
        return () => clearTimeout(handler)
    }, [localSearch, onChangeText])

    useEffect(() => {
        if (value === '') {
            setLocalSearch('')
        }
    }, [value])

    return (
        <Searchbar
            placeholder={placeholder}
            value={localSearch}
            onChangeText={setLocalSearch}
            style={[styles.searchbar, { backgroundColor: theme.colors.surface }]}
        />
    )
}

const styles = StyleSheet.create({
    searchbar: {
        flex: 1,
        elevation: 0,
    },
})
